export default theme => ({
  root: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    backgroundColor: "transparent",
    zIndex: 100
  },

  contentWrap: {
    backgroundColor: theme.palette.common.white,
  },

  topbar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    boxSizing: "border-box",
    height: 44,
    padding: "10px 40px",
    backgroundColor: "#f5f5f5",
    borderBottom: "1px solid #e3e3e3",
  },
  backerPill: {
    display: "inline-flex",
    alignItems: "center",
    gap: 7,
    padding: "5px 12px",
    borderRadius: 999,
    border: "1px solid #dbdbdb",
    backgroundColor: "transparent",
    boxSizing: "border-box",
  },
  backerLogo: {
    display: "block",
    width: 45,
    height: 11,
    objectFit: "contain",
  },
  backerText: {
    margin: 0,
    fontFamily: '"Instrument Sans", Helvetica, Arial, sans-serif',
    fontWeight: 500,
    fontSize: theme.typography.pxToRem(12),
    lineHeight: 1.2,
    color: "#6b6b6b",
    whiteSpace: "nowrap",
  },
  topbarRight: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: 32,
  },
  emergency: {
    display: "flex",
    alignItems: "center",
    gap: 7,
    textDecoration: "none",
    background: "none",
    border: 0,
    padding: 0,
    cursor: "pointer",
    font: "inherit",
  },
  emergencyDot: {
    width: 7,
    height: 7,
    borderRadius: "50%",
    backgroundColor: "#e02214",
    flexShrink: 0,
  },
  emergencyLabel: {
    fontFamily: '"Instrument Sans", Helvetica, Arial, sans-serif',
    fontWeight: 500,
    fontSize: theme.typography.pxToRem(12),
    lineHeight: 1.2,
    color: "#6b6b6b",
    whiteSpace: "nowrap",
  },
  emergencyPhone: {
    fontFamily: '"Instrument Sans", Helvetica, Arial, sans-serif',
    fontWeight: 700,
    fontSize: theme.typography.pxToRem(16),
    lineHeight: 1.25,
    color: "#ff8200",
    whiteSpace: "nowrap",
  },
  loginLink: {
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    textDecoration: "none",
    background: "none",
    border: 0,
    padding: 0,
    cursor: "pointer",
    fontFamily: '"Instrument Sans", Helvetica, Arial, sans-serif',
    fontWeight: 500,
    fontSize: theme.typography.pxToRem(12),
    lineHeight: 1.2,
    color: "#333232",
    whiteSpace: "nowrap",
    "&:hover": {
      color: "#282727",
    },
  },
  loginIcon: {
    display: "block",
    width: 15,
    height: 15,
  },

  topIconsContainer: {
    padding: "0 118px 10px",
    marginBottom: theme.spacing(["5", 1]),
    fontSize: theme.typography.pxToRem(12),
    fontWeight: 500
  },

  comboChangeSite: {
    cursor: "pointer"
  },

  headerContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    boxSizing: "border-box",
    padding: "18px 40px",
    minHeight: 76,
  },

  headerLeft: {
    display: "flex",
    alignItems: "center",
    gap: 28,
    minWidth: 0,
    flex: "0 1 auto",
  },

  eccoLogo: {
    position: "relative",
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
  },

  logo: {
    display: "block",
    width: 103,
    height: 34,
  },

  eccoLinks: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    flexWrap: "nowrap",
    gap: 20,
    fontWeight: theme.typography.fontWeightMedium,
    marginTop: 0,
  },

  eccoLink: {
    textTransform: "uppercase",
    fontSize: theme.typography.pxToRem(15),
    padding: `0 ${theme.spacing(["5", 2])}px`,
    color: theme.palette.grey.eccoGrey,
    height: "1em",
    marginRight: 8,
    cursor: "pointer",
    display: "flex",
    alignItems: "center",

    "&:hover, &$active": {
      color: theme.palette.primary.main
    }
  },

  active: {},

  headerCta: {
    flexShrink: 0,
    "&&": {
      borderRadius: 6,
      margin: 0,
      minHeight: 40,
      height: 40,
      minWidth: 61,
      width: "auto",
      padding: "12px 16px",
      fontFamily: '"Instrument Sans", Helvetica, Arial, sans-serif',
      fontSize: theme.typography.pxToRem(14),
      fontWeight: 600,
      lineHeight: 1.15,
      textTransform: "none",
      boxShadow: "none",
    },
  },

  eccoButtonsContainer: {
    display: "flex",
    alignItems: "center",
    flexShrink: 0,
    marginLeft: "auto",
  },

  buttonHeaderText: {
    fontSize: theme.typography.pxToRem(13)
  },

  /* Figma menu-items-desktop: franja gris full-width bajo el header */
  megaMenu: {
    width: "100%",
    boxSizing: "border-box",
    backgroundColor: "#f4f4f4",
    paddingTop: 16,
    paddingBottom: 16,
  },

  megaMenuList: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: 10,
    boxSizing: "border-box",
    paddingRight: 40,
  },

  megaLink: {
    display: "inline-block",
    margin: 0,
    padding: 0,
    textDecoration: "none",
    fontFamily: '"Instrument Sans", Helvetica, Arial, sans-serif',
    fontWeight: 400,
    fontSize: theme.typography.pxToRem(14),
    lineHeight: 1.25,
    color: "#6b6b6b",
    whiteSpace: "nowrap",
    "&:hover": {
      color: "#333232",
    },
  },

  megaLinkHeading: {
    fontWeight: 500,
    fontSize: theme.typography.pxToRem(12),
    lineHeight: 1.2,
    color: "#333232",
    "&:hover": {
      color: "#333232",
    },
  },

  swissGroupIconWrapped: {
    margin: 0,
    paddingRight: 0,
    height: "100%"
  }
});
